module.exports = __webpack_public_path__ + "img/jdt-card.ff6b3995.png";